$(function () {
  $(".dog-kind-list").each(function () {
    var listOther = $(this).find(".other"),
      listBtn = $(this).find(".js-list-btn");

    if ($("li.other input:radio:checked").length == 0) {
      listOther.hide();
    } else {
      listBtn.hide();
    }

    if (listOther.length == "0") {
      listBtn.hide();
    }

    listBtn.click(function (e) {
      e.stopPropagation();
      e.preventDefault();

      listOther.fadeIn(400);
      $(this).parent().fadeOut(200);
    });
  });

  if ($("#partner_weight").length) {
    $("#partner_weight").val() || $("#partner_weight").val("0.00");
    var weight = $("#partner_weight").val();
    $("#weight_integer").val(weight.split(".")[0]);
    // 1.0の様に小数点第一位を0にした場合、
    // $("#partner_weight").val()で取得できる値は1(小数点第一位を切り捨てた値)になり、
    // weight.split(".")[1] = undefined になるので、その場合は0にする
    if (!weight.split(".")[1]){
      $("#weight_decimal").val(0);
      $("#weight_decimal_second").val(0);
    } else {
      $("#weight_decimal").val(weight.split(".")[1].slice(0,1) || 0);
      $("#weight_decimal_second").val(weight.split(".")[1].slice(1,2) || 0);
    }
  }

  $("#weight_integer, #weight_decimal, #weight_decimal_second").change(function () {
    tmp_partner_weight = Math.ceil(parseInt($("#weight_integer").val())) +
    Math.ceil(parseInt($("#weight_decimal").val())) / 10 +
    Math.ceil(parseInt($("#weight_decimal_second").val())) / 100;
    partner_weight = tmp_partner_weight.toFixed(2);
    $("#partner_weight").val(partner_weight);
  });

  $("#step2-back").click(function (e) {
    e.preventDefault();
    $(this).parents("form").attr("action", "/partners/step1");
    $(this).parents("form").submit();
  });

  $("#step3-back").click(function (e) {
    e.preventDefault();
    $(this).parents("form").attr("action", "/partners/step2");
    $(this).parents("form").submit();
  });

  $("#step4-back").click(function (e) {
    e.preventDefault();
    $(this).parents("form").attr("action", "/partners/step3");
    $(this).parents("form").submit();
  });

  $("#complete-back").click(function (e) {
    e.preventDefault();
    $(this).parents("form").attr("action", "/partners/step4");
    $(this).parents("form").submit();
  });

  $("#counselling1-back").click(function (e) {
    e.preventDefault();
    $(this).parents("form").attr("action", "/partners/complete");
    $(this).parents("form").submit();
  });

  $("#counselling2-back").click(function (e) {
    e.preventDefault();
    $(this).parents("form").attr("action", "/partners/counselling1");
    $(this).parents("form").submit();
  });

  $("#counselling3-back").click(function (e) {
    e.preventDefault();
    $(this).parents("form").attr("action", "/partners/counselling2");
    $(this).parents("form").submit();
  });

  $("#counselling4-back").click(function (e) {
    e.preventDefault();
    $(this).parents("form").attr("action", "/partners/counselling3");
    $(this).parents("form").submit();
  });

  $("#counselling5-back").click(function (e) {
    e.preventDefault();
    $(this).parents("form").attr("action", "/partners/counselling4");
    $(this).parents("form").submit();
  });
});
